<div class="header-container">
    <h1>Base de datos</h1>
    <db-search></db-search>
</div>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
@for (link of links; track link.location) {
    <a mat-tab-link *ngIf="!link.if" [disabled]="link.guard" routerLink="{{ link.location }}" (click)="activeLink = link" [active]="activeLink === link">
        {{ link.label }}
    </a>
}
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>